<script lang="ts" setup>
import type { BrandColor, SizeVariants } from '~kui/types/kui';

type SpotlightSize = Extract<SizeVariants, 'sm' | 'md' | 'lg'>;

interface Props {
  color: BrandColor;
  size?: SpotlightSize;
}

const props = withDefaults(defineProps<Props>(), {
  size: 'md',
});

const spotlightClasses = computed(() =>
  twMerge(cva('rounded-full blur-xl transition-colors duration-300', {
    variants: {
      color: {
        'lime': 'bg-secondary',
        'coral': 'bg-brand-coral',
        'pink': 'bg-brand-pink',
        'purple': 'bg-brand-purple',
        'orange': 'bg-brand-orange',
        'blue': 'bg-brand-blue',
        'yellow': 'bg-brand-yellow',
        'black': 'bg-black',
        'off-black': 'bg-primary',
        'success': 'bg-success',
        'error': 'bg-destructive',
        'info': 'bg-info',
      },
      size: {
        sm: 'size-48',
        md: 'size-64',
        lg: 'size-96',
      },
    },
  })({ color: props.color, size: props.size })),
);
</script>

<template>
  <!-- Always decorative: a colour bloom with no content, so it never reaches the a11y tree. -->
  <div :class="spotlightClasses" aria-hidden="true" />
</template>
